<template>
    <el-dialog class="dialog-box" v-if="flowDialog" :visible.sync="flowDialog">
        <img class="flow-img" src="@File~/assets/out-flow.png" />
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
           flowDialog:false 
        }
    }
}
</script>

<style lang="scss" scoped>
    .dialog-box{
        ::v-deep .el-dialog{
            max-width: 1270px;
            width: auto;
            max-height: 852px;
            height: auto;
            margin-top: 3.5vh !important;
        }
        ::v-deep .el-dialog__header{
            padding: 0;
        }

        ::v-deep .el-dialog__headerbtn{
            font-size: 24px;
            top: 10px;
            right: 10px;
        }
        .flow-img{
            display: block;
            max-width: 1230px;
            width: 100%;
            max-height: 812px;
            height: auto;
            overflow: hidden;
            margin: 0 auto;
        }
    }
</style>